import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
// import "../../css/bootstrap.min.css";
import "../../../css/font.css";
import axios from "axios";
import {schoolJobsurl} from '../../../apis/urls'
import {schoolsurl, api} from '../../../apis/urls'
import ReactPaginate from 'react-paginate';
import moment from "moment";
import { $ } from "react-jquery-plugin";
import { decode } from "html-entities";

const JobComponent = ()=> {

	const { id } = useParams();
	let urole = localStorage.getItem('userrole')
	useEffect(() => {
    $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        Listing();
        SchoolName();
    },[]
    );





	  const [result,setResult] = useState([]);
    const [schname,setSchName] = useState([]);
    const [searchTitle, setSearchTitle] = useState("")
    const [currentpage, setCurrentpage] = useState([]);
    const [totalPages, setTotalPages] = useState([]);
    const [totalItems, setTotalItems] = useState([]);


    let counts = 0;
      if(result)
      {
          counts = result.length;
      }

	  let navigate = useNavigate();

	const Listing = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolJobsurl+'/'+id+'?page='+0+'&size='+50,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setResult(response.data.data.items);
            //console.log('datas',response.data.data.items)
            setCurrentpage(response.data.data.currentPage)
            setTotalPages(response.data.data.totalPages)
            setTotalItems(response.data.data.totalItems)
            //console.log(response.data)
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

    const SchoolName = () => {

        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: schoolsurl+'/'+id,

            timeout: 1000000,

            headers: {'authorization': token}

          });
          
          instance.get('').then((response) =>{
            
            setSchName(response?.data?.data);

           
          }).catch((error) =>{
            
            console.log('error',error.message)
            

          });
    }

	const DeleteJob = (jobid) => {

        let r = window.confirm("Are you sure you want to delete this Job?");

        if(r == true){
            
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: schoolJobsurl+'/'+id+'/'+jobid,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                Listing();
                navigate("/jobs/"+id)
            
            }).catch((error) =>{
                
                console.log('error',error.message)
            });
        }
    }


    const refreshList = () => {
      setResult(null);
  };


  let token = "Bearer "+localStorage.getItem('token');
  const instances = axios.create({
      baseURL: api,
      timeout: 1000000,
      headers: {'authorization': token}
  });

  const findByTitles = name => {
      return instances.get(schoolJobsurl+'/school/'+id+`?search=${name}`);
  };

  const onChangeSearchTitle = (e) => {
    const searchTitle = e.target.value;
    setSearchTitle(searchTitle);
      findByTitles(searchTitle)
        .then(response => {
          setResult(response.data.data.items);
          console.log(response.data.data);
        })
        .catch(e => {
          console.log(e);
        });
  };

  const findByTitlesss = option => {
      return instances.get('jobs/school/'+id+`?status=${option}`);
  };

  const onChangeSearchTitles = (e) => {
      const searchTitle = e.target.value;
      findByTitlesss(searchTitle)
        .then(response => {
          setResult(response.data.data.items);
          console.log(response.data.data.items);
        })
        .catch(e => {
          console.log(e);
        });
  };

   //PAGINATION


     // Invoke when user click to request another page.
     const handlePageClick = (event) => { console.log('EVENTSSS',event)

     const instance = axios.create({
         baseURL: schoolJobsurl+'/'+id+'?page='+event.selected+'&size='+50,
         timeout: 1000000,
         headers: {'authorization': token}
       });

       

     instance.get('').then(res => {

         setResult(res.data.data.items)
     
     }).catch(e => {
     //console.log('errorshw',e);
     localStorage.removeItem('token')
     navigate("/")
     });


 };
	
    return(
        <div>
        <aside class="right-side areas">
			<div class="content-area dash-contentss">
              <div class="page-title-wrpr">
                <div class="page-title-left-column">
                     <i class="icon-suitcase1"></i>
                    <h2 class="page-title">Jobs</h2>
                </div>
                <div class="page-rightside-action-column">
                {/* <div class="input-groups mt-3 mb-3 search-grp">
                    <div class="input-group-prepends">
                    <select class="form-controls custom-select" onChange={onChangeSearchTitles}>
                            <option value="none" selected disabled hidden>STATUS</option>
                            <option value=" ">ALL</option>
                            <option>ACTIVE</option>
                            <option>INACTIVE</option>
                            <option>DELETE</option>
                        </select> 
                    </div>
                    <input type="text" 
                    class="form-controls search-bar"             
                    value={searchTitle}
                    onChange={onChangeSearchTitle}
                    placeholder="Search" />
                    <button  class="btn btn-search icon-search"></button>
                    </div> */}
                    <Link to={"/add_jobs/"+id} data-toggle="tooltip" title="" className="addbtnitem-link text-anchor" data-original-title="Add New Jobs"><i className="icon-add"></i><span>Add New Jobs</span> </Link>
                </div>
            </div>
            
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                {
                  urole === 'SUPERADMIN'?
                  (<li class="breadcrumb-item"><Link to="/school_list">{decode(schname.name)}</Link></li>)
                  :null
                }
                
                <li class="breadcrumb-item active" aria-current="page">Jobs</li>
              </ol>
            </nav>
            {result?
            (<div class="number-of">
                Displaying 1-{counts} of {totalItems} results.
            </div>):null
            }

            <div class="faculty-list-wrpr list-wrpr">
				{
					result?.map((item,index)=> (
						
							
							
						
						
						<div class="list" key={index}>
							
						<div class="row">
							<div class="col-md-3">
                                <div class="update-date">
									<span class="jobs-user">{decode(item.title)}</span>
									<span class="desig">Title</span>
								</div>
								
							</div>

							<div class="col-md-3">
								<div class="update-date">
									<span class="jobs-user">{decode(item.contact_name)}</span>
									<span class="desig">Contact Name</span>
								</div>
							</div>
							
							<div class="col-md-2">
								<div class="update-date">
									<span class="date-wrpr"><i class="icon-calendar6"></i>{moment(item.createdAt).format('LL')}</span>
									<span class="desig">Created on</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="update-date">
									<span class="date-wrpr"><i class="icon-calendar6"></i>{moment(item.expires_on).format('LL')}</span>
									<span class="desig">Expires on</span>
								</div>
							</div>
							<div class="col-md-2">
								<div class="list-action-wrpr text-right  roundicons-text">
                  <Link  to={"/jobview/"+id+"/"+item.id}  title="View"><i class="view icon-eye style={{backgroundColor:'#eabb73'}}"></i><span>View</span></Link>
									{/* <Link to={"/edit_jobs/"+id+"/"+item.id} data-toggle="tooltip" title="Edit"   class="edit icon-pencil3"></Link>
									<button onClick={() =>  { DeleteJob(item.id) } } data-toggle="tooltip" title="Delete"   class="delete icon-close1"></button> */}
								</div>
							</div>
						</div>
					</div>

					)
					
					)
				}
        
        {
        !result?
        (<div className="nodata">
            <h2>Sorry! No Jobs Found</h2>
        </div>):null
        }

       
            </div>               
            {result?
            (<div class="number-of footer-number">
                Displaying 1-{counts} of {totalItems} results.
            </div>):null
            }

                <div class="pagination-wrpr">
                    <ReactPaginate
                            className="pagination page"
                            pageClassName="page-item"
                            activeClassName="active"
                            nextLabel=">"
                            previousLabel="<"
                            previousClassName="page-link p-link"
                            nextClassName="page-link p-link"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={10}
                            pageCount={totalPages}
                            renderOnZeroPageCount={1}
                        />
                </div>
                      
        </div>


        </aside>
    </div>
    );
}

export default JobComponent
